import { useState, useCallback } from 'react';

/**
 * Custom hook to manage AccessManagement2NModal state
 * Consolidates 8 separate useState calls into organized state objects
 * with semantic action creators
 */
export const useAccessManagement2NModalState = () => {
  // Tab navigation state
  const [activeTab, setActiveTab] = useState({
    showGroups: false,
    showAccessRules: true,
    showTimeProfiles: false,
    showResources: false,
  });

  // Selected items state
  const [selected, setSelected] = useState({
    group: null,
    accessRule: null,
    timeProfile: null,
    resource: null,
  });

  // Adding/Editing modes state
  const [isAdding, setIsAdding] = useState({
    resource: false,
    group: false,
    timeProfile: false,
    accessRule: false,
  });

  // Action: Switch between tabs
  const switchTab = useCallback((tabName) => {
    const resetState = {
      showGroups: false,
      showAccessRules: false,
      showTimeProfiles: false,
      showResources: false,
      [tabName]: true,
    };

    setActiveTab(resetState);

    // Reset selections when switching tabs
    setSelected({
      group: null,
      accessRule: null,
      timeProfile: null,
      resource: null,
    });

    // Reset adding modes when switching tabs
    setIsAdding({
      resource: false,
      group: false,
      timeProfile: false,
      accessRule: false,
    });
  }, []);

  // Action: Update selected item
  const updateSelected = useCallback((itemType, value) => {
    setSelected((prev) => ({
      ...prev,
      [itemType]: value,
    }));
  }, []);

  // Action: Update adding mode
  const updateAdding = useCallback((itemType, value) => {
    setIsAdding((prev) => ({
      ...prev,
      [itemType]: value,
    }));
  }, []);

  return {
    activeTab,
    selected,
    isAdding,
    switchTab,
    updateSelected,
    updateAdding,
  };
};

